module.exports = __webpack_public_path__ + "images/emoji/weary.32809468d62cc3b3f623.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/weary.png
// module id = HsUn
// module chunks = 24